import type { TFunction } from "i18next";
import { AlertStatus } from "@/alerts/types/machine-alert.ts";

/**
 * `AlertStatus` is a wire value the API sends and matches on, so it is never
 * translated in place — this maps it to a display string at the render edge.
 * An unrecognised status falls back to the raw value rather than rendering
 * nothing.
 */
export const alertStatusLabel = (
  status: AlertStatus,
  t: TFunction<"machines">,
): string => {
  switch (status) {
    case AlertStatus.Pending:
      return t("alertStatus.pending");
    case AlertStatus.Resolved:
      return t("alertStatus.resolved");
    case AlertStatus.Ignored:
      return t("alertStatus.ignored");
    default:
      return status;
  }
};
